import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { AiOutlineSend } from "react-icons/ai";
import axios from "axios";
import { mirage } from "ldrs";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { FaDeleteLeft } from "react-icons/fa6";
import { SiGooglegemini } from "react-icons/si";
import localforage from "localforage";
import "../style/home.css";
import { FaBookmark } from "react-icons/fa6";
import { MdNavigateNext } from "react-icons/md";
import { animateScroll as scroll } from "react-scroll";
import { FiArrowUpCircle } from "react-icons/fi";

gsap.registerPlugin(ScrollTrigger);
var info2, span2;
const Home = () => {
  mirage.register();
  const input_field = useRef(null);
  const loader = useRef(null);
  const typeref = useRef(null);
  const scrollUp = useRef(null);
  const typeOption = useRef(null);
  const options = useRef(null);
  const options_scroll = useRef(null);
  const messageText = useRef(null);
  const message = useRef(null);
  const messageSpanSvg = useRef(null);
  const input_pass = useRef(null);
  const memotype = useRef(null);
  const addlibtn = useRef(null);
  const [input, setInput] = useState("");
  const [option, setoption] = useState("");
  const [pass, setPass] = useState("");
  const [liText, setliText] = useState("");
  const [addli, setaddli] = useState(false);
  const [saved, setsaved] = useState(false);
  const [newlielement, setnewlielement] = useState(false);
  async function submit() {
    showloader();
    const data = {
      prompt: input,
    };
    setInput("");
    input_field.current.textContent = "";
    try {
      const response = await axios.post(
        "https://joodyy.netlify.app/.netlify/functions/app/ai",
        // "http://localhost:5001/ai",
        data
      );
      hideloader();
      var text = organizeText(response.data);
      createresult(text);
    } catch (error) {
      console.error(error);
      setInput("");
      setsaved(null);
      hideloader();
      await showMessage("server error");
    }
  }
  async function summarize() {
    showloader();
    const data = {
      prompt: input,
    };
    setInput("");
    input_field.current.textContent = "";
    try {
      const response = await axios.post(
        "https://joodyy.netlify.app/.netlify/functions/app/summarize",
        data
      );
      hideloader();
      var text = organizeText(response.data);
      createresult(text);
    } catch (error) {
      setInput("");
      setsaved(null);
      hideloader();
      await showMessage("server error");
    }
  }
  async function translate() {
    showloader();
    const data = {
      prompt: input,
    };
    setInput("");
    input_field.current.textContent = "";
    try {
      const response = await axios.post(
        "https://joodyy.netlify.app/.netlify/functions/app/translate",
        data
      );
      hideloader();
      console.log(response.data);
      var text = organizeText(response.data);
      createresult(text);
    } catch (error) {
      setInput("");
      setsaved(null);
      hideloader();
      await showMessage("server error");
    }
  }
  async function trueOrfalse() {
    showloader();
    const data = {
      prompt: input,
    };
    setInput("");
    input_field.current.textContent = "";
    try {
      const response = await axios.post(
        "https://joodyy.netlify.app/.netlify/functions/app/trueOrfalse",
        data
      );
      hideloader();
      var text = organizeText(response.data);
      createresult(text);
    } catch (error) {
      setInput("");
      setsaved(null);
      hideloader();
      await showMessage("server error");
    }
  }
  async function multipleChoice() {
    showloader();
    const data = {
      prompt: input,
    };
    setInput("");
    input_field.current.textContent = "";
    try {
      const response = await axios.post(
        "https://joodyy.netlify.app/.netlify/functions/app/multipleChoice",
        data
      );
      hideloader();
      var text = organizeText(response.data);
      createresult(text);
    } catch (error) {
      setInput("");
      setsaved(null);
      hideloader();
      await showMessage("server error");
    }
  }
  const tl = gsap.timeline({});
  function createresult(data) {
    var section = document.querySelector("section");
    var result = document.createElement("div");
    result.className = "result";
    var h4 = document.createElement("h4");
    h4.id = "Q";
    var spansvg = `<span id="gemini-svg">
              <svg
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8.016A8.522 8.522 0 008.016 16h-.032A8.521 8.521 0 000 8.016v-.032A8.521 8.521 0 007.984 0h.032A8.522 8.522 0 0016 7.984v.032z"
                  fill="url(#prefix__paint0_radial_980_20147)"
                />
                <defs>
                  <radialGradient
                    id="prefix__paint0_radial_980_20147"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(16.1326 5.4553 -43.70045 129.2322 1.588 6.503)"
                  >
                    <stop offset=".067" stop-color="#9168C0" />
                    <stop offset=".343" stop-color="#5684D1" />
                    <stop offset=".672" stop-color="#1BA1E3" />
                  </radialGradient>
                </defs>
              </svg>
            </span>`;
    var question = document.createElement("span");
    question.id = "question";
    question.textContent = input;
    h4.innerHTML = spansvg;
    h4.appendChild(question);
    var div = document.createElement("div");
    if (isArabicText(data)) {
      div.dir = "rtl";
      div.style = "font-family:var(--arabic_font);";
    } else {
      div.dir = "ltr";
    }
    div.id = "answer";
    div.innerHTML = data;
    var actions = document.createElement("div");
    actions.id = "actions";
    var span = document.createElement("span");
    span.id = Math.floor(Math.random() * (10000000 - 10000 + 1)) + 10000;
    span.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--svg-false-clr)"><path d="M200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Z"/></svg>`;
    span.dataset.click = "false";
    span.addEventListener("click", () => {
      var Q = document.createElement("span");
      Q.id = "question";
      var element = question;
      Q.appendChild(element);
      tl.kill();
      if (span.dataset.click == "false") {
        const data = {
          id: span.id,
          category: "",
          question: Q.innerHTML,
          answer: div.innerHTML,
        };
        info2 = data;
        span2 = span;

        showMemos(data, span);
      } else {
        const data = {
          id: span.id,
        };
        removememo(data, span);
      }
      h4.appendChild(element);
    });
    actions.appendChild(span);
    var copy = document.createElement("span");
    copy.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--svg-false-clr)"><path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"/></svg>`;
    copy.addEventListener("click", async () => {
      var range = document.createRange();

      range.selectNode(result.querySelector("#answer>#answer_text"));
      window.getSelection().removeAllRanges(); // clear current selection
      window.getSelection().addRange(range); // to select text
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      setsaved("done");
      await showMessage("text copied");
    });
    actions.appendChild(copy);

    // ? **********
    var repeat = document.createElement("span");
    repeat.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--svg-false-clr)"><path d="M440-122q-121-15-200.5-105.5T160-440q0-66 26-126.5T260-672l57 57q-38 34-57.5 79T240-440q0 88 56 155.5T440-202v80Zm80 0v-80q87-16 143.5-83T720-440q0-100-70-170t-170-70h-3l44 44-56 56-140-140 140-140 56 56-44 44h3q134 0 227 93t93 227q0 121-79.5 211.5T520-122Z"/></svg>`;
    repeat.addEventListener("click", async () => {
      setInput(question.textContent);
      var svg = repeat.querySelector("svg");
      var inputplaceHolder = document.querySelector(".input");
      inputplaceHolder.dataset.placeholder = "regenerating text ...";
      svg.dataset.active = "true";
      repeatQuest(svg, inputplaceHolder);
    });
    actions.appendChild(repeat);
    // ? ******************

    result.appendChild(h4);
    result.appendChild(div);
    result.appendChild(actions);
    section.appendChild(result);
    scroll.scrollToBottom();
  }
  async function repeatQuest(svg, inputplaceHolder) {
    var id = document.querySelector(".type").id;
    if (id == "1") {
      await summarize();
      svg.dataset.active = "false";
      inputplaceHolder.dataset.placeholder = "Summarize text...";
    } else if (id == "2") {
      await translate();
      svg.dataset.active = "false";
      inputplaceHolder.dataset.placeholder = "Translate text...";
    } else if (id == "3") {
      await trueOrfalse();
      svg.dataset.active = "false";
      inputplaceHolder.dataset.placeholder = "Create T&F questions...";
    } else if (id == "4") {
      await multipleChoice();
      svg.dataset.active = "false";
      inputplaceHolder.dataset.placeholder =
        "Create multiple choices questions...";
    } else {
      await submit();
      svg.dataset.active = "false";
      inputplaceHolder.dataset.placeholder = "Ask me any question";
    }
  }
  async function memo(data, span) {
    const pass = await localforage.getItem("passcode");
    if (pass) {
      showloader();
      try {
        const response = await axios.post(
          "https://joodyy.netlify.app/.netlify/functions/app/create/memo",
          data
        );
        hideloader();
        if (response.data.state == true) {
          setsaved(true);
          span.dataset.click = "true";
          hideCreateMemoForm();
          await showMessage(response.data.message);
        } else {
          setsaved(false);
          span.dataset.click = "false";
          hideCreateMemoForm();
          await showMessage(response.data.message);
        }
      } catch (error) {
        setsaved(null);
        hideloader();
        await showMessage("server error");
      }
    } else {
      show();
    }
  }
  async function removememo(data, span) {
    const pass = localforage.getItem("pass");
    if (pass) {
      showloader();
      try {
        const response = await axios.post(
          "https://joodyy.netlify.app/.netlify/functions/app/create/removememo",
          data
        );
        hideloader();
        if (response.data.state == true) {
          setsaved(false);
          span.dataset.click = "false";
          await showMessage(response.data.message);
        } else {
          setsaved(true);
          span.dataset.click = "true";
          await showMessage(response.data.message);
        }
      } catch (error) {
        setsaved(null);
        hideloader();
        await showMessage("server error");
      }
    } else {
      show();
    }
  }
  async function showMessage(text) {
    const tl = gsap.timeline({});
    message.current.style = "";
    await tl
      .fromTo(
        message.current,
        {
          top: "-2rem",
        },
        {
          top: "1rem",
          ease: "elastic.out(1,0.5)",
          duration: 1.5,
          overwrite: true,
        }
      )
      .fromTo(
        message.current,
        {
          minWidth: "0px",
        },
        {
          minWidth: "180px",
          ease: "elastic.out(1,0.75)",
          duration: 1,
        }
      )
      .fromTo(
        messageText.current,
        {
          opacity: 0,
          flexGrow: 0,
          textContent: "",
          height: "0",
        },
        {
          textContent: text,
          flexGrow: 1,
          height: "fit-content",
          opacity: 1,
        }
      )
      .fromTo(
        messageSpanSvg.current,
        {
          opacity: 0,
        },
        {
          opacity: 1,
        }
      )
      .to(messageText.current, {
        opacity: 0,
        delay: 2,
      })
      .to(messageText.current, {
        flexGrow: 0,
        height: "0",
      })
      .to(messageSpanSvg.current, {
        opacity: 0,
        delay: -1,
      })
      .to(messageText.current, {
        textContent: "",
      })
      .to(message.current, {
        minWidth: "0px",
      })
      .to(message.current, {
        top: "-3rem",
      });
  }
  function isArabicText(text) {
    const arabicRegExp = /[\u0600-\u06FF\u0750-\u077F]/;
    return arabicRegExp.test(text);
  }
  function organizeText(text) {
    // Remove bold formatting
    text = text.replace(/\*\*/g, "");
    // Split text into lines
    const lines = text.split("\n");

    // Function to process a single line
    function processLine(line, index) {
      var arr = [];
      if (line.startsWith("```")) {
        for (let i = index; i < lines.length; i++) {
          console.log(lines[i]);
          if (lines[i + 1] && lines[i + 1].startsWith("```")) {
            break;
          } else {
            arr.push(lines.splice(i, 1));
            arr.push(`<br>`);
          }
        }
        // // Code block detected
        // const codeBlockContent = [];
        // let isCodeBlock = true;

        // // Process lines until the closing ``` is found
        // var x = lines.shift().trim();
        // while (isCodeBlock && lines.length > 0) {
        //   line = lines.shift().trim();
        //   console.log(line);
        //   if (line.endsWith("```")) {
        //     isCodeBlock = false;
        //   } else {
        //     codeBlockContent.push(line);
        //     codeBlockContent.push(`<br>`);
        //   }
        // }
        // return;
        // Wrap code block content in <code> tags
        return `<div id="code"><code>${arr.join("")}</code></div>`;
      } else if (line.endsWith(":")) {
        return `<h4>${line.slice(0).trim()}</h4>`;
      } else if (line.startsWith("*")) {
        const listItemContent = line.slice(1).trim();
        return `<li>${listItemContent}</li>`;
      } else if (line.trim() !== "") {
        // Default case: treat as regular text
        return `<p>${line.trim()}</p>`;
      }
    }

    // Process each line and join them
    const htmlContent = lines.map(processLine).join("");

    // Wrap content in a top-level element (e.g., `<div>`)
    return `<div id="answer_text">${htmlContent}</div>`;
  }
  function showloader() {
    gsap.to(loader.current, { opacity: 1 });
  }
  function hideloader() {
    gsap.to(loader.current, { opacity: 0 });
  }
  useLayoutEffect(() => {
    var title = document.querySelector(".hero>#color");
    var options = document.querySelectorAll(".option");
    splitText(title);
    gsap.to(title.querySelectorAll("span"), {
      color: "transparent",
      stagger: 0.1,
    });
    gsap.fromTo(
      options,
      { opacity: 0, y: 10 },
      {
        y: 0,
        opacity: 1,
        delay: 1,
        duration: 1,
        stagger: 0.3,
      }
    );
    gsap.to(".propmt", {
      bottom: "1rem",
      ease: "elastic.out(1,0.75)",
      duration: 1.5,
      delay: 0.5,
    });
    var op = document.querySelector(".options_scroll");
    op.addEventListener("click", () => {
      op.toggleAttribute("data-active"); // Toggle between "true" and no attribute
    });
  }, []);
  function splitText(text) {
    var arr = text.textContent.split("");
    text.innerHTML = "";
    for (let i = 0; i < arr.length; i++) {
      text.innerHTML += `<span>` + arr[i] + `</span>`;
    }
  }
  const typeGsap = gsap.timeline();
  function removetype() {
    var inputplaceHolder = document.querySelector(".input");
    inputplaceHolder.dataset.placeholder = "Ask me any question";
    typeGsap
      .to(typeOption.current, { opacity: 0, duration: 0.3 })
      .to(typeref.current, {
        opacity: 0,
        x: 10,
        pointerEvents: "none",
        onComplete: () => {
          setoption("");
        },
      });
  }
  function showtype() {
    typeGsap
      .fromTo(typeOption.current, { opacity: 0 }, { opacity: 0 })
      .to(typeref.current, {
        x: 10,
        opacity: 0,
        pointerEvents: "none",
      })
      .to(typeref.current, {
        x: 0,
        opacity: 1,
        pointerEvents: "all",
      })
      .to(typeOption.current, { opacity: 1 });
  }
  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".options",
        start: "90%",
        scrub: 0.5,
      },
    });
    tl.fromTo(
      [options_scroll.current, scrollUp.current],
      {
        opacity: 0,
        pointerEvents: "none",
      },
      {
        opacity: 1,
        pointerEvents: "all",
        duration: 0.5,
      }
    ); // Fade in options_scroll element on scroll trigger

    return () => tl.kill(); // Cleanup timeline on component unmount
  }, []);
  async function addpasscode() {
    showloader();
    try {
      const data = {
        pass: pass,
      };
      const response = await axios.post(
        "https://joodyy.netlify.app/.netlify/functions/app/create/pass",
        data
      );

      hideloader();
      if (response.data.state == true) {
        hide();
        await localforage.setItem("passcode", pass);
      } else {
        setsaved(null);
        await showMessage(response.data.message);
      }
    } catch (error) {
      setsaved(null);
      hideloader();
      await showMessage("server error");
    }
  }
  function hide() {
    gsap.to(input_pass.current, {
      y: 100,
      opacity: 0,
      pointerEvents: "none",
      duration: 0.7,
      ease: "expo.out",
    });
  }
  function show() {
    var tl = gsap.timeline();
    tl.fromTo(
      input_pass.current,
      { y: 100, opacity: 0, pointerEvents: "none" },
      {
        y: 0,
        opacity: 1,
        pointerEvents: "all",
        duration: 0.7,
        ease: "expo.out",
      }
    );
  }
  async function showMemos() {
    const pass = await localforage.getItem("passcode");
    if (pass) {
      showloader();
      try {
        const res = await axios.get(
          "https://joodyy.netlify.app/.netlify/functions/app/create/allcategory"
        );
        if (res.data.state == true) {
          const newli = await res.data.allCategories.map((data, index) => (
            <li
              key={index}
              onClick={() => {
                info2.category = data.category;
                memo(info2, span2);
              }}
            >
              <span>
                <FaBookmark />
              </span>
              <p>{data.category}</p>
              <span>
                <MdNavigateNext />
              </span>
            </li>
          ));
          setnewlielement((prev) => (prev = newli));
          setTimeout(() => {
            playlist();
          }, 100);
        } else {
          tl.fromTo(
            memotype.current,
            { opacity: 0, pointerEvents: "none" },
            {
              opacity: 1,
              pointerEvents: "all",
              duration: 0.7,
              ease: "expo.out",
            }
          );
        }
        hideloader();
      } catch (error) {
        setsaved(null);
        hideloader();
        await showMessage("server error");
      }
    } else {
      show();
    }
  }
  function playlist() {
    var tl = gsap.timeline();
    tl.fromTo(
      memotype.current,
      { opacity: 0, pointerEvents: "none" },
      {
        opacity: 1,
        pointerEvents: "all",
        duration: 0.7,
        ease: "expo.out",
      }
    ).fromTo(
      ".memotype__list>li",
      { opacity: 0, y: 10 },
      { opacity: 1, y: 0, stagger: 0.15 }
    );
  }
  function hideCreateMemoForm() {
    var tl = gsap.timeline();
    tl.to(memotype.current, {
      opacity: 0,
      pointerEvents: "none",
      duration: 0.7,
      ease: "expo.out",
    });
  }
  function getTime() {
    var date = new Date();
    if (date.getHours() >= 12) {
      return "eveing";
    } else if (date.getHours() < 12) {
      return "morning";
    }
  }
  const li = (
    <li>
      <span>
        <FaBookmark />
      </span>
      <input
        type=""
        onInput={(e) => {
          setliText(e.target.value);
        }}
        inputMode="search"
      />
      <span>
        <MdNavigateNext />
      </span>
    </li>
  );
  async function addCatogry() {
    if (liText.length > 0) {
      try {
        const data = {
          category: liText,
        };
        const response = await axios.post(
          "https://joodyy.netlify.app/.netlify/functions/app/create/category",
          data
        );
        if (response.data.state == true) {
          await showMemos();
          setsaved((prev) => (prev = "done"));
          await showMessage(response.data.message);
        } else {
          setsaved((prev) => (prev = null));
          await showMessage(response.data.message);
        }
      } catch (error) {
        setsaved(null);
        hideloader();
        await showMessage("server error");
      }
    } else {
      setsaved((prev) => (prev = null));
      await showMessage("enter a name");
    }
  }
  const summrizesvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
    >
      <path d="M160-360v-80h400v80H160Zm0-160v-80h640v80H160Z" />
    </svg>
  );
  const translatesvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
    >
      <path d="m476-80 182-480h84L924-80h-84l-43-122H603L560-80h-84ZM160-200l-56-56 202-202q-35-35-63.5-80T190-640h84q20 39 40 68t48 58q33-33 68.5-92.5T484-720H40v-80h280v-80h80v80h280v80H564q-21 72-63 148t-83 116l96 98-30 82-122-125-202 201Zm468-72h144l-72-204-72 204Z" />
    </svg>
  );
  const trueOrFalsesvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
    >
      <path d="M240-120q-50 0-85-35t-35-85v-400h80v400q0 17 11.5 28.5T240-200q17 0 28.5-11.5T280-240v-480q0-50 35-85t85-35q50 0 85 35t35 85v480q0 17 11.5 28.5T560-200q17 0 28.5-11.5T600-240v-480q0-50 35-85t85-35q50 0 85 35t35 85v400h-80v-400q0-17-11.5-28.5T720-760q-17 0-28.5 11.5T680-720v480q0 50-35 85t-85 35q-50 0-85-35t-35-85v-480q0-17-11.5-28.5T400-760q-17 0-28.5 11.5T360-720v480q0 50-35 85t-85 35Z" />
    </svg>
  );
  const nultiplesvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
    >
      <path d="M240-160q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm480 0q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM480-560q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Z" />
    </svg>
  );
  const memoSaved = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="m438-400 198-198-57-56-141 141-57-57-57 57 114 113ZM200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Z" />
    </svg>
  );
  const memoRemoved = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M840-680H600v-80h240v80ZM200-120v-640q0-33 23.5-56.5T280-840h240v80H280v518l200-86 200 86v-278h80v400L480-240 200-120Zm80-640h240-240Z" />
    </svg>
  );
  const error = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>
  );
  const done = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
    </svg>
  );

  return (
    <article
      onDoubleClick={() => {
        hide();
        hideCreateMemoForm();
      }}
    >
      <div className="message" ref={message}>
        <p ref={messageText}></p>
        <span ref={messageSpanSvg}>
          {saved === false && memoRemoved}
          {saved === true && memoSaved}
          {saved === null && error}
          {saved === "done" && done}
        </span>
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          addCatogry();
          setliText("");
          const tl = gsap.timeline({});
          setaddli((prev) => (prev = false));
          tl.to(addlibtn.current, { rotate: 0 });
        }}
        className="memotype"
        ref={memotype}
      >
        <div className="memotype__title">
          <h3>create & save memo</h3>
          <button
            form="fake"
            ref={addlibtn}
            onClick={(e) => {
              const tl = gsap.timeline({});
              if (addli == false) {
                setaddli((prev) => (prev = true));
                tl.to(e.currentTarget, { rotate: 45 });
              } else {
                setaddli((prev) => (prev = false));
                tl.to(e.currentTarget, { rotate: 0 });
              }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="var(--svg-true-clr)"
            >
              <path d="M440-440H240q-17 0-28.5-11.5T200-480q0-17 11.5-28.5T240-520h200v-200q0-17 11.5-28.5T480-760q17 0 28.5 11.5T520-720v200h200q17 0 28.5 11.5T760-480q0 17-11.5 28.5T720-440H520v200q0 17-11.5 28.5T480-200q-17 0-28.5-11.5T440-240v-200Z" />
            </svg>
          </button>
        </div>
        <ul className="memotype__list">
          {newlielement}
          {addli == true && li}
        </ul>
      </form>
      <form
        className="input_pass"
        ref={input_pass}
        onSubmit={(e) => {
          e.preventDefault();
          addpasscode();
        }}
      >
        <label htmlFor="pass">
          <p>enter passcode</p>
          <input
            type="text"
            id="pass"
            name="pass"
            onInput={(e) => {
              setPass(e.target.value);
            }}
          />
        </label>
        <span>
          <p>enter passcode to continue</p>
        </span>
      </form>
      <div className="type" id={option} ref={typeref}>
        <span ref={typeOption}>
          {option === "1" && summrizesvg}
          {option === "2" && translatesvg}
          {option === "3" && trueOrFalsesvg}
          {option === "4" && nultiplesvg}
        </span>
        <button onClick={removetype}>
          <FaDeleteLeft />
        </button>
      </div>
      <div
        className="scrollUp"
        onClick={() => {
          scroll.scrollToTop();
        }}
        ref={scrollUp}
      >
        <FiArrowUpCircle />
      </div>
      <div className="hero">
        <h1 id="color">{getTime()} Joody</h1>
        <h1 id="normal">
          lets make the best results together <br />
          <span>always for help.✨</span>
        </h1>
      </div>
      <section>
        <div className="options" ref={options}>
          <div
            className="option"
            onClick={() => {
              setoption("1");
              showtype();
            }}
          >
            <div className="title">
              <span>summarize</span> and get the <span>key points </span>
              from any text
            </div>
            <div className="logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#fff"
              >
                <path d="M160-360v-80h400v80H160Zm0-160v-80h640v80H160Z" />
              </svg>
            </div>
          </div>
          <div
            className="option"
            onClick={() => {
              setoption("2");
              showtype();
            }}
          >
            <div className="title">
              <span>translate</span> any text to Arabic
            </div>
            <div className="logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#fff"
              >
                <path d="m476-80 182-480h84L924-80h-84l-43-122H603L560-80h-84ZM160-200l-56-56 202-202q-35-35-63.5-80T190-640h84q20 39 40 68t48 58q33-33 68.5-92.5T484-720H40v-80h280v-80h80v80h280v80H564q-21 72-63 148t-83 116l96 98-30 82-122-125-202 201Zm468-72h144l-72-204-72 204Z" />
              </svg>
            </div>
          </div>
          <div
            className="option"
            onClick={() => {
              setoption("3");
              showtype();
            }}
          >
            <div className="title">
              create <span>TRUE</span> or <span>FALSE</span> questions
            </div>
            <div className="logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#fff"
              >
                <path d="M240-120q-50 0-85-35t-35-85v-400h80v400q0 17 11.5 28.5T240-200q17 0 28.5-11.5T280-240v-480q0-50 35-85t85-35q50 0 85 35t35 85v480q0 17 11.5 28.5T560-200q17 0 28.5-11.5T600-240v-480q0-50 35-85t85-35q50 0 85 35t35 85v400h-80v-400q0-17-11.5-28.5T720-760q-17 0-28.5 11.5T680-720v480q0 50-35 85t-85 35q-50 0-85-35t-35-85v-480q0-17-11.5-28.5T400-760q-17 0-28.5 11.5T360-720v480q0 50-35 85t-85 35Z" />
              </svg>
            </div>
          </div>
          <div
            className="option"
            onClick={() => {
              setoption("4");
              showtype();
            }}
          >
            <div className="title">
              create <span>multiple choices</span> questions
            </div>
            <div className="logo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#fff"
              >
                <path d="M240-160q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm480 0q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35ZM480-560q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Z" />
              </svg>
            </div>
          </div>
        </div>
      </section>
      <form
        className="propmt"
        action="#"
        method="post"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className="prompt_container">
          <div
            ref={input_field}
            className="input"
            data-placeholder="Ask me any question"
            contentEditable="true"
            id="text"
            onInput={(e) => {
              setInput(e.target.textContent);
            }}
          ></div>
          <div className="btns">
            <button className="options_scroll" ref={options_scroll}>
              <span>
                <SiGooglegemini />
              </span>
              <div
                className="circle"
                onClick={() => {
                  var inputplaceHolder = document.querySelector(".input");
                  inputplaceHolder.dataset.placeholder = "Summarize text...";
                  setoption("1");
                  showtype();
                }}
              >
                {summrizesvg}
              </div>
              <div
                className="circle"
                onClick={() => {
                  var inputplaceHolder = document.querySelector(".input");
                  inputplaceHolder.dataset.placeholder = "Translate text...";
                  setoption("2");
                  showtype();
                }}
              >
                {translatesvg}
              </div>
              <div
                className="circle"
                onClick={() => {
                  var inputplaceHolder = document.querySelector(".input");
                  inputplaceHolder.dataset.placeholder =
                    "Create T&F questions...";
                  setoption("3");
                  showtype();
                }}
              >
                {trueOrFalsesvg}
              </div>
              <div
                className="circle"
                onClick={() => {
                  var inputplaceHolder = document.querySelector(".input");
                  inputplaceHolder.dataset.placeholder =
                    "Create multiple choices questions...";
                  setoption("4");
                  showtype();
                }}
              >
                {nultiplesvg}
              </div>
            </button>
            <button
              onClick={() => {
                var inputplaceHolder = document.querySelector(".input");
                if (option == "1") {
                  summarize();
                  inputplaceHolder.dataset.placeholder = "Summarize text...";
                } else if (option == "2") {
                  translate();
                  inputplaceHolder.dataset.placeholder = "Translate text...";
                } else if (option == "3") {
                  trueOrfalse();
                  inputplaceHolder.dataset.placeholder =
                    "Create T&F questions...";
                } else if (option == "4") {
                  multipleChoice();
                  inputplaceHolder.dataset.placeholder =
                    "Create multiple choices questions...";
                } else {
                  submit();
                  inputplaceHolder.dataset.placeholder = "Ask me any question";
                }
              }}
            >
              <AiOutlineSend />
            </button>
          </div>
        </div>
      </form>
      <div className="loader" ref={loader}>
        <l-mirage size="60" speed="2.5" color="black"></l-mirage>
      </div>
    </article>
  );
};

export default Home;
